import {rightPanelCentralizedControl} from './index';
import {pushGtmDrawModeStart} from '../config/gtm';

export const drawModeReducer = (drawMode = {status: false, type: false, report: false, subscribe: false}, action) => {

    const rightPanelCentralizedControlData = rightPanelCentralizedControl('draw-mode-panel', action);
    if(rightPanelCentralizedControlData !== null){
        return rightPanelCentralizedControlData;
    }

    let newDrawMode = Object.assign({}, drawMode);
    newDrawMode.isUpdate = false;
    if (action.type === 'CLOSE_DRAW_MODE_PANEL') {
        newDrawMode.status = false;
        newDrawMode.type = false;
        newDrawMode.report = false;
        newDrawMode.data = {};
    } else if (action.type === 'DISPLAY_DRAW_MODE_START_PANEL') {
        newDrawMode.report = false;
        if (action.payload.forceDisplay === true) {
            newDrawMode.status = 'draw-start'
            newDrawMode.data = {};
        } else if (newDrawMode.status === 'draw-start') {
            newDrawMode.status = false;
            newDrawMode.type = false;
            newDrawMode.data = {};
        } else {
            newDrawMode.status = 'draw-start'
            newDrawMode.data = {};
        }
    } else if (action.type === ' DRAW_MODE_DISPLAY_TOGGLE') {
        if(newDrawMode.status === false){
            newDrawMode.status = 'draw-start'
            newDrawMode.type = false;
            newDrawMode.report = false;
            newDrawMode.data = {};
        }
        else{
            newDrawMode.status = false;
            newDrawMode.type = false;
            newDrawMode.report = false;
            newDrawMode.data = {};
        }
    } else if (action.type === 'START_DRAW_MODE') {
        newDrawMode.type = action.payload;
        newDrawMode.data = {};
        newDrawMode.polygonData = null;
        pushGtmDrawModeStart();
    } else if (action.type === 'DRAW_MODE_ANALYZE') {
        newDrawMode.status = 'analyze';
        newDrawMode.data = action.payload;
    } else if (action.type === 'DRAW_MODE_POINT_UPDATE') {
        newDrawMode.data.coordinate = action.payload;
        newDrawMode.isUpdate = true;
    } else if(action.type === 'DRAW_MODE_LINE_STRING_UPDATE'){
        newDrawMode.data.coordinate = action.payload;
        newDrawMode.isUpdate = true;
    } else if(action.type === 'DRAW_MODE_REPORT_TOGGLE') {
        newDrawMode.report = !drawMode.report;
        newDrawMode.subscribe = false;
    } else if(action.type === 'DRAW_MODE_SUBSCRIBE_TOGGLE'){
        newDrawMode.subscribe = !drawMode.subscribe;
        newDrawMode.report = false;
    } else if(action.type === 'DRAW_MODE_POLYGON_UPDATE_FILTER'){
        if(action.payload.startDate){
            newDrawMode.data.filter.startDate = action.payload.startDate;
        }
        if(action.payload.endDate){
            newDrawMode.data.filter.endDate = action.payload.endDate;
        }
        if(action.payload.confidenceLevel){
            newDrawMode.data.filter.confidenceLevel = action.payload.confidenceLevel;
        }
        if(action.payload.source){
            newDrawMode.data.filter.source = action.payload.source;
        }
        newDrawMode.polygonData.shouldUpdate = true;
    } else if(action.type === 'DRAW_MODE_POLYGON_REGISTER'){
        newDrawMode.polygonData = action.payload;
        newDrawMode.polygonData.shouldUpdate = true;
    } else if(action.type === 'DRAW_MODE_POLYGON_UPDATE_ANALYSIS_DATA'){
        newDrawMode.polygonData.data = action.payload;
        newDrawMode.polygonData.shouldUpdate = false;

    }


    return newDrawMode;
}